import { notification } from './src/notification'

export default notification


// WEBPACK FOOTER //
// ./~/iexplore/components/notification/index.js